var CompareAndUpdateCandidateDetailsModalController = /** @class */ (function () {
    function CompareAndUpdateCandidateDetailsModalController() {
        // this.candidateConflictDetails = this.resolve.candidateConflictDetails;
    }
    CompareAndUpdateCandidateDetailsModalController.prototype.$onInit = function () {
        this.candidateConflictDetails = this.resolve.candidateConflictDetails;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    };
    CompareAndUpdateCandidateDetailsModalController.prototype.saveCallback = function (contactDetails) {
        this.callbackObject = { callbackType: 'save', entity: contactDetails };
        this.closeModal();
    };
    CompareAndUpdateCandidateDetailsModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    CompareAndUpdateCandidateDetailsModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    return CompareAndUpdateCandidateDetailsModalController;
}());
// import * as TEMPLATE from './compare-and-update-candidate-details-modal.html';
import * as TEMPLATE from 'raw-loader!./compare-and-update-candidate-details-modal.html';
export var CompareAndUpdateCandidateDetailsModalComponent = {
    selector: 'compareAndUpdateCandidateDetailsModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: CompareAndUpdateCandidateDetailsModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/addCandidates/addCandidates/uploadResumes/compareAndUpdateCandidateDetailsModal/compare-and-update-candidate-details-modal.html'
    }
};
//# sourceMappingURL=compare-and-update-candidate-details-modal.component.js.map